import { APP_ROLES } from "duck";
import { UserRoleEnum } from "requests";

export const USER_ROLES = [
  UserRoleEnum.RoleSurgeon,
  UserRoleEnum.RoleDvm,
  UserRoleEnum.RoleDvmDavdc,
  UserRoleEnum.RoleDoctor,
  UserRoleEnum.RoleAnesthesiologist,
  UserRoleEnum.RoleAnesthetist,
  UserRoleEnum.RoleNurse,
  UserRoleEnum.RoleLvt,
  UserRoleEnum.RoleRvt,
  UserRoleEnum.RoleCvt,
  UserRoleEnum.RoleTechnician,
  UserRoleEnum.RoleVeterinaryTechnician,
  UserRoleEnum.RoleAssistant
].map(userRole => ({
  value: userRole,
  label: APP_ROLES[userRole]
}));
